export const LABELS = {
  COMPLETED: "Completed",
  UPCOMING: "Upcoming",
  SESSION: "Session",
  STATUS: "Status",
  SESSION_DATE: "Session Date",
  BOOKED_ATTENDEES: "Booked attendees",
  TOTAL_ATTENDANCE: "Total attendance count",
  TOTAL_ATTENDANCE_COUNT: "Total attendance count",
  TOTAL_ATTENDANCE_PERCENT: "Total attendance %",
  FULL: "Full",
  PARTIAL: "Partial",
  ABSENT: "Absent",
  UNRECOGNIZED: "Unrecognized",
  ACTION: "Action",
  VIEW_ATTENDEES: "View attendees",
  VIEW_REPORT: "View Report",
  NOT_APPLICABLE: "N/A",
  EXCEL_EXPORT: "Export Data",
  NO_DATA: "--",
  SESSION_PREFIX: "Session",
  SHOWING: "Showing",
  OF: "of",
  SESSIONS: "sessions",
  TOTAL_SESSIONS: "Total Sessions",
  OVERALL_ATTENDANCE: "Overall Attendance",
  PERFECT_ATTENDANCE: "Perfect Attendance",
  HIGHLY_ENGAGED: "Highly Engaged",
  SCHEDULE: "Schedule",
  SESSION_PARTICIPANTS: "Session Participants",
  CUSTOMER_NAME: "Customer Name",
  NAME: "Name",
  EMAIL: "Email",
  JOINED_WITH_EMAIL: "Joined with email",
  PHONE: "Phone",
  PHONE_NUMBER: "Phone Number",
  ATTENDED: "Attended",
  TOTAL_MINS: "Total Mins",
  TOTAL_MINUTES_ATTENDED: "Total Minutes Attended",
  TIMES_JOINED: "Times Joined",
  JOIN_TIME: "Join time",
  LEAVE_TIME: "Leave time",
  DURATION: "Duration",
  RECONCILE: "Reconcile",
  MAP_TO_BOOKING: "Map to booking",
  CREATE_NEW_BOOKING: "Create new booking",
  RECONCILE_PARTICIPANT: "Reconcile Participant",
  RECONCILING: "Reconciling...",
  RECONCILE_UNRECOGNIZED_TITLE: "Map to an existing booking",
  UNRECOGNIZED_GUEST_HEADER: "Captured Zoom Participant Data",
  UNRECOGNIZED_EXPLANATION:
    "Confirming mapping will attribute this participant's attendance data (join time, leave time, duration) to the selected booking, recalculate attendance stats, and email the customer about the ID mismatch.",
  MAP_WARNING_NOTE:
    "Confirming will send an email notification to the customer explaining the ID mismatch and updating their attendance record.",
  SEARCH_BOOKINGS_LABEL: "Search Existing Bookings for this Session",
  SEARCHING_BOOKINGS: "Searching bookings...",
  SEARCH_BOOKINGS_PLACEHOLDER:
    "Search existing bookings by name, email, or phone...",
  NO_BOOKINGS_FOUND: "No matching bookings found for this session.",
  CREATE_BOOKING_SHORTCUT: "Create new booking instead",
  CONFIRM_MAPPING: "Confirm Mapping",
  MAPPING_IN_PROGRESS: "Mapping...",
  CANCEL: "Cancel",
  FULL_ATTENDANCE_TAB: "Full Attendance",
  PARTIAL_ATTENDANCE_TAB: "Partial Attendance",
  NO_ATTENDANCE_TAB: "No Attendance",
  UNRECOGNIZED_ATTENDEES_TAB: "Unrecognized Attendees",
  ALL_TAB: "All",
  DURATION_MINS_PLACEHOLDER: "Duration (in mins)",
  DURATION_PCT_PLACEHOLDER: "Duration (in %)",
  FIXED_CLASS_DEFAULT_LABEL: "Fixed Class",
  EXPORT_CSV_FILENAME: "session_participants",
  PARTICIPANT_PREFIX: "participant_",
  ZOOM_EMAIL_NOTICE:
    "Note: Zoom attendance data does not provide phone numbers—only joined email addresses. For phone dial-in or unrecognized participants, the email field may display a Zoom-generated identifier or remain blank.",
  ATTENDEE_ENTITY: "attendee",
  SEND_MESSAGE_TITLE: "Send Message",
  SELECT_BROADCAST_MEDIUM: "Select Broadcast medium",
  TOTAL_SESSIONS_WITH_ATTENDEES: "Total Sessions with Attendees",
  TOTAL_ATTENDEES: "Total Attendees",
  BOOKED_ATTENDEES_TITLE: "Booked Attendees",
  ATTENDANCE_TITLE: "Attendance",
  TOOLTIPS: {
    TOTAL_SESSIONS_WITH_ATTENDEES:
      "Number of sessions for this offering, which have atleast one attendee",
    OVERALL_ATTENDANCE: "Avg of total attendance % across all sessions",
    PERFECT_ATTENDANCE:
      "Unique attendees who received Full Attendance in every completed session they booked.",
    HIGHLY_ENGAGED:
      "Unique attendees who attended (Full or Partial) at least 50% of the completed sessions they booked.",
    TOTAL_ATTENDEES:
      "Unique attendees who attended (Full or Partial) at least 1 session they booked.",
    BOOKED_ATTENDEES:
      "Unique attendees booked for this session, deduped by email. A snapshot taken before the session starts — can differ from other sessions in this offering due to cancellations or new bookings made afterward.",
    ATTENDANCE:
      "Share of booked attendees marked Full or Partial attendance for this session.",
    FULL_ATTENDANCE:
      "Attendees present for 60% or more of this session's duration.",
    ABSENT: "Booked attendees who did not join this session at all.",
    UNRECOGNIZED:
      "Zoom participants in this session who couldn't be matched to a booking and still need to be mapped or converted to a new booking.",
  },
};
